import { render, staticRenderFns } from "./VirtualDataTable.vue?vue&type=template&id=19892d22&"
import script from "./VirtualDataTable.vue?vue&type=script&lang=js&"
export * from "./VirtualDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports